module.exports = __webpack_public_path__ + "img/IMG_1381.bf09d335.jpeg";